import { render, staticRenderFns } from "./_Page027.vue?vue&type=template&id=88bdbd1a&scoped=true&"
import script from "./_Page027.vue?vue&type=script&lang=js&"
export * from "./_Page027.vue?vue&type=script&lang=js&"
import style0 from "./_Page027.vue?vue&type=style&index=0&id=88bdbd1a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88bdbd1a",
  null
  
)

export default component.exports